import { Box, Heading, Text, Stack } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { BlogPost } from "./blogData";

export const BlogCard = (post: BlogPost) => {

  return (
    <Box
      as={Link}
      to={`/blog/${post.slug}`}
      role="group"
      position="relative"
      height="340px"
      borderRadius="2xl"
      overflow="hidden"
      bgImage={`url(${post.thumbnail})`}
      bgSize="cover"
      bgPosition="center"
      transition="all 0.25s ease"
      _hover={{
        transform: "translateY(-6px)",
      }}
    >
      <Box position="absolute" inset={0} bg="blackAlpha.100" />

      <Stack
        position="absolute"
        bottom={4}
        left={4}
        right={4}
        spacing={3}
        p={5}
        borderRadius="xl"
        bg="linear-gradient(
          135deg,
          rgba(2, 72, 86, 0.85),
          rgba(0, 113, 136, 0.75)
        )"
        backdropFilter="blur(10px)"
        border="1px solid rgba(255,255,255,0.12)"
        boxShadow="0 20px 40px rgba(0,0,0,0.35)"
        transition="all 0.25s ease"
        _groupHover={{
          boxShadow: "0 30px 60px rgba(0,0,0,0.45)",
        }}
      >
        <Heading fontSize="lg" color="white" lineHeight="short">
          {post.title}
        </Heading>

        <Text fontSize="sm" color="whiteAlpha.800" noOfLines={2}>
          {post.content
            .filter((item) => item.type === "text")
            .map((item) => item.content)}
        </Text>

        <Text
          fontSize="sm"
          fontWeight="medium"
          color="white"
          opacity={{ base: 1, md: 0 }}
          transform={{ base: "none", md: "translateY(6px)" }}
          transition="all 0.25s ease"
          _groupHover={{
            opacity: 1,
            transform: "translateY(0)",
          }}
        >
          Tovább a cikkhez →
        </Text>
      </Stack>
    </Box>
  );
};

export default BlogCard;
